import { createContext } from 'react'

export const EncuestaContext = createContext()
